﻿import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { CONFIG } from '../../core/config';
import { GroupingListOfDebatesByYear } from '../../core/models/debates/statistics/grouping-list-of-debates-by-year';
import { NumberOfCommentsByDebate } from '../../core/models/debates/statistics/number-of-comments-by-debate';
import { NumberOfCommentsByGender } from '../../core/models/debates/statistics/number-of-comments-by-gender';
import { NumberOfCommentsBySensitiveCategory } from '../../core/models/debates/statistics/number-of-comments-by-sensitiveCategory';
import { NumberOfCommentsByYearGroup } from '../../core/models/debates/statistics/number-of-comments-by-yearGroup';
import { NumberOfDebatesByKind } from '../../core/models/debates/statistics/number-of-debates-by-kind';
import { NumberOfDiscussionsByDebate } from '../../core/models/debates/statistics/number-of-discussions-by-debate';
import { NumberOfParticipantsByDebate } from '../../core/models/debates/statistics/number-of-participants-by-debate';
import { NumberOfSessionByLocation } from '../../core/models/debates/statistics/number-of-session-by-location';
import { NumberOfSessionsByDebate } from '../../core/models/debates/statistics/number-of-sessions-by-debate';
import { SearchStatistics } from '../../core/models/debates/statistics/search-statistics';
import { ExceptionService } from '../../core/services/exception.service';
import { SpinnerService } from '../../core/spinner/spinner.service';

@Injectable()
export class StatisticsService {
    constructor(private _http: HttpClient,
        private _exceptionService: ExceptionService,
        private _spinnerService: SpinnerService) { }

    getNumberOfDebatesByKind(searchModel: SearchStatistics): Observable<NumberOfDebatesByKind[]> {
        this._spinnerService.show();
        return this._http.post<NumberOfDebatesByKind[]>(CONFIG.baseUrls.debatesStatistic.getNumberOfDebatesByKind, searchModel)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    getNumberOfDebatesByMonth(searchModel: SearchStatistics): Observable<GroupingListOfDebatesByYear[]> {
        this._spinnerService.show();
        return this._http.post<GroupingListOfDebatesByYear[]>(CONFIG.baseUrls.debatesStatistic.getNumberOfDebatesByMonth, searchModel)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    getNumberOfSessionByLocation(searchModel: SearchStatistics): Observable<NumberOfSessionByLocation[]> {
        this._spinnerService.show();
        return this._http.post<NumberOfSessionByLocation[]>(CONFIG.baseUrls.debatesStatistic.getNumberOfSessionByLocation, searchModel)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }
    getNumberOfCommentsByDebate(searchModel: SearchStatistics): Observable<NumberOfCommentsByDebate[]> {
        this._spinnerService.show();
        return this._http.post<NumberOfCommentsByDebate[]>(CONFIG.baseUrls.debatesStatistic.getNumberOfCommentsByDebate, searchModel)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }
    getNumberOfCommentsByGender(searchModel: SearchStatistics): Observable<NumberOfCommentsByGender[]> {
        this._spinnerService.show();
        return this._http.post<NumberOfCommentsByGender[]>(CONFIG.baseUrls.debatesStatistic.getNumberOfCommentsByGender, searchModel)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }
    getNumberOfCommentsBySensitiveCategory(searchModel: SearchStatistics): Observable<NumberOfCommentsBySensitiveCategory[]> {
        this._spinnerService.show();
        return this._http.post<NumberOfCommentsBySensitiveCategory[]>(CONFIG.baseUrls.debatesStatistic.getNumberOfCommentsBySensitiveCategory, searchModel)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }
    getNumberOfCommentsByYearGroup(searchModel: SearchStatistics): Observable<NumberOfCommentsByYearGroup[]> {
        this._spinnerService.show();
        return this._http.post<NumberOfCommentsByYearGroup[]>(CONFIG.baseUrls.debatesStatistic.getNumberOfCommentsByYearGroup, searchModel)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }
    
    getNumberOfSessionsByDebate(searchModel: SearchStatistics): Observable<NumberOfSessionsByDebate[]> {
        this._spinnerService.show();
        return this._http.post<NumberOfSessionsByDebate[]>(CONFIG.baseUrls.debatesStatistic.getNumberOfSessionsByDebate, searchModel)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    getNumberOfDiscussionsByDebate(searchModel: SearchStatistics): Observable<NumberOfDiscussionsByDebate[]> {
        this._spinnerService.show();
        return this._http.post<NumberOfDiscussionsByDebate[]>(CONFIG.baseUrls.debatesStatistic.getNumberOfDiscussionsByDebate, searchModel)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    getNumberOfParticipantsByDebate(searchModel: SearchStatistics): Observable<NumberOfParticipantsByDebate[]> {
        this._spinnerService.show();
        return this._http.post<NumberOfParticipantsByDebate[]>(CONFIG.baseUrls.debatesStatistic.getNumberOfParticipantsByDebate, searchModel)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }
}